// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminCommission = (client) => ({
    /**
     * `POST /admin/commission/rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateCommissionRule
     * @source packages/modules/commission/src/api/admin/commission/rules/route.ts
     */
    createRule: (body, query, headers) => client.fetch("/admin/commission/rules", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/commission/rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteCommissionRuleById
     * @source packages/modules/commission/src/api/admin/commission/rules/[id]/route.ts
     */
    deleteRule: (id, body, query, headers) => client.fetch(buildPath("/admin/commission/rules/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/commission/commission-lines`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListCommissionLines
     * @source packages/modules/commission/src/api/admin/commission/commission-lines/route.ts
     */
    listCommissionLines: (query, headers) => client.fetch("/admin/commission/commission-lines", { method: "GET", query, headers }),
    /**
     * `GET /admin/commission/rules`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListCommissionRules
     * @source packages/modules/commission/src/api/admin/commission/rules/route.ts
     */
    listRules: (query, headers) => client.fetch("/admin/commission/rules", { method: "GET", query, headers }),
    /**
     * `GET /admin/commission/default`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetDefaultCommissionRule
     * @source packages/modules/commission/src/api/admin/commission/default/route.ts
     */
    retrieveDefault: (query, headers) => client.fetch("/admin/commission/default", { method: "GET", query, headers }),
    /**
     * `GET /admin/commission/rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetCommissionRuleById
     * @source packages/modules/commission/src/api/admin/commission/rules/[id]/route.ts
     */
    retrieveRule: (id, query, headers) => client.fetch(buildPath("/admin/commission/rules/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/commission/search`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/modules/commission/src/api/admin/commission/search/route.ts
     */
    search: (query, headers) => client.fetch("/admin/commission/search", { method: "GET", query, headers }),
    /**
     * `POST /admin/commission/default`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpsertDefaultCommissionRule
     * @source packages/modules/commission/src/api/admin/commission/default/route.ts
     */
    updateDefault: (body, query, headers) => client.fetch("/admin/commission/default", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/commission/rules/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateCommissionRuleById
     * @source packages/modules/commission/src/api/admin/commission/rules/[id]/route.ts
     */
    updateRule: (id, body, query, headers) => client.fetch(buildPath("/admin/commission/rules/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=commission.js.map